import { eventChannel } from 'redux-saga'
import { takeLatest, put, fork, take, cancel, cancelled, call } from 'redux-saga/effects'
import { interviewRequestListView } from '../../reducks'

// Polling every 10 minutes
const pollingPeriod = 10 * 60 * 1000

function* initPollingSaga() {
  // Start the polling task in the background
  const pollingTask = yield fork(backgroundPolling)
  // Listen for the reset action and cancel the background task
  yield take(interviewRequestListView.INTERVIEW_REQUEST_POLLING_END)
  yield cancel(pollingTask)
}

function* backgroundPolling() {
  const channel = yield call(pollingChannel)
  try {
    while (true) {
      const action = yield take(channel)
      yield put(action)
    }
  } finally {
    // Executes when the background task is cancelled
    if (yield cancelled()) {
      channel.close()
    }
  }
}

function pollingChannel() {
  return eventChannel(emitter => {
    // Create the interval and execute the polling when triggered
    const pollingInterval = setInterval(() => {
      emitter(interviewRequestListView.fetchInterviewRequests())
    }, pollingPeriod)

    return () => {
      // Cancel the interval
      clearInterval(pollingInterval)
    }
  })
}

export default function* watchInterviewRequestListChannel() {
  yield takeLatest(interviewRequestListView.INTERVIEW_REQUEST_POLLING_INIT, initPollingSaga)
}
